import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    CreateInventoryStockAdjustmentInput,
    CreateInventoryStockAdjustmentResponse,
} from '../../types/inventory';

const createStockAdjustment = async (
    sessionId: string,
    input: CreateInventoryStockAdjustmentInput,
): Promise<CreateInventoryStockAdjustmentResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/adjustments/create`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useCreateInventoryStockAdjustment = (
    options?: UseMutationOptions<
        CreateInventoryStockAdjustmentResponse,
        unknown,
        CreateInventoryStockAdjustmentInput
    >,
) => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (input: CreateInventoryStockAdjustmentInput) =>
            createStockAdjustment(sessionContext?.sessionId ?? '', input),
        ...options,
    });
};
